module.exports = __webpack_public_path__ + "static/media/FATIMA ALZAHRAA SABSABI.4ed40e8a.png";